import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import RelativeLink from "../common/RelativeLink";
import * as types from "../../constants/ComponentConstants";
import TabNavIcon from "../common/TabNavIcon";
import Bead from "../layout/Bead";
import { Popup } from 'semantic-ui-react';

const TabNavItem = ({ color, iconType, disabled, display, to, visible, hideText, showBead, customNavAction }) => {
	const colorText = color ? color : "blue";
	const navItemClassName = {
		"c-anchor-nav__item": true,
		["item--" + colorText]: true,
		"c-anchor-nav__item--disabled": disabled
	};
	const displayText = hideText ? "" : (<p>{display}</p>);

	const beadProps = {
		beadstate: "half",
		small: true,
		tooltipText: `In dit formulier-gedeelte moeten nog verplichte velden ingevuld worden.`,
		color: color,
		style: {
			'position': 'absolute',
			'transform': 'translate(34px, -10px)'
		}
	};

	const relativeLink =
		<div>
			{!disabled ?
				(customNavAction ?
					<div>
						<RelativeLink to={to} onClick={(e) => { e.preventDefault(); customNavAction(); }} className="ui-tab" disabled>
							<TabNavIcon type={iconType} color={colorText} />{displayText}
						</RelativeLink>
					</div>
					: <RelativeLink to={to} className="ui-tab">
						<TabNavIcon type={iconType} color={colorText} />{displayText}
					</RelativeLink>) :
				<span><TabNavIcon type={iconType} color={colorText} />{displayText}</span>}
		</div>;

	return (visible ? <div className={classnames(navItemClassName)}>
		{showBead ? <Bead {...beadProps} /> : null}
		<Popup trigger={relativeLink} content={display} />
	</div> : null);
};

TabNavItem.propTypes = {
	display: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
	color: PropTypes.string,
	iconType: PropTypes.string,
	disabled: PropTypes.bool,
	visible: PropTypes.bool,
	showTooltip: PropTypes.bool,
	hideText: PropTypes.bool,
	showBead: PropTypes.bool,
	customNavAction: PropTypes.func
};

export default TabNavItem;